/**
 * Utilities for managing session verification state
 */
import { Session } from '@supabase/supabase-js'

// Session verification status key in sessionStorage
export const SESSION_VERIFIED_KEY = 'boardgames-today-session-verified'

/**
 * Check if the session has been verified
 * @returns true if the session has been verified
 */
export function isSessionVerified(): boolean {
  try {
    return sessionStorage.getItem(SESSION_VERIFIED_KEY) === 'true'
  } catch (_e) {
    void 0 // Intentionally ignored
    return false
  }
}

/**
 * Mark the session as verified
 */
export function markSessionVerified(): void {
  try {
    sessionStorage.setItem(SESSION_VERIFIED_KEY, 'true')
  } catch (_e) {
    void 0 // Intentionally ignored
    // Failed to mark session as verified in sessionStorage
  }
}

/**
 * Clear the session verification flag
 */
export function clearSessionVerified(): void {
  try {
    sessionStorage.removeItem(SESSION_VERIFIED_KEY)
  } catch (_e) {
    void 0 // Intentionally ignored
    // Failed to clear session verification from sessionStorage
  }
}

export const getSessionFromLocalStorage = (): Session | null => {
  try {
    const sessionStr = localStorage.getItem('supabase.auth.token')
    if (!sessionStr) return null
    const session = JSON.parse(sessionStr)
    return session
  } catch (_e) {
    void 0 // Intentionally ignored
    return null
  }
}

export const getSessionFromCookie = (): Session | null => {
  try {
    // Implementation depends on how cookies are stored
    return null
  } catch (_e) {
    void 0 // Intentionally ignored
    return null
  }
}

export const getSessionFromStorage = (): Session | null => {
  try {
    // Try localStorage first, then cookies
    return getSessionFromLocalStorage() || getSessionFromCookie()
  } catch (_e) {
    void 0 // Intentionally ignored
    return null
  }
}
